import { render } from "./sliderOne.vue?vue&type=template&id=5625a5b8&scoped=true"
import script from "./sliderOne.vue?vue&type=script&lang=js"
export * from "./sliderOne.vue?vue&type=script&lang=js"

import "./sliderOne.vue?vue&type=style&index=0&id=5625a5b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5625a5b8"]])

export default __exports__